module.exports = __webpack_public_path__ + "img/AX.5545e1a2.png";